import bindEvent from '../../scripts/util/bindEvent';
import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import isElement from '../../scripts/util/isElement';
// import showMore from '../show-more/show-more';
import {forEach} from 'ramda';
import {build, compile} from '../../scripts/renderTemplate';
import sendForm from '../../scripts/form';
import {reset as clearAvatar} from '../avatar/';
import $ from 'jquery';

const selectors = {
	form: '.js-review-form',
	submit: '.js-button-submit',
	popup: '.js-popup-form',
	button: '.js-popup-button',
	close: '.js-popup-close',
	body: '.js-body',
	content: '.js-reviews',
	review: '#js-review',
	cardReview: '.js-card-reviews',
	avatar: '.js-avatar',
	page: '.page',
	input: '.reviews .js-field-input'
};

const classes = {
	activeForm: 'reviews__form_state_active',
	activePopup: 'reviews__col-form_state_active',
	fade: 'card-reviews_fade',
	hidden: 'page_state_hidden'
};

const form = () => document.querySelectorAll(selectors.form);
const pageToggler = () => {
	const page = qs(selectors.page);
	const popup = qs(selectors.popup);
	const width = window.innerWidth;
	const open = popup.classList.contains(classes.activePopup);


	if ( width >= 1024) {
		page.classList.remove(classes.hidden);
	} else if ( width <= 1024 && open) {
		page.classList.add(classes.hidden);
	}
};

const onClick = () => {
	const popup = qs(selectors.popup);
	const heightBody = document.documentElement.scrollHeight;

	popup.style.height = heightBody + 'px';
	popup.classList.toggle(classes.activePopup);

	const page = qs(selectors.page);

	if (window.innerWidth <= 1024 ) {
		page.classList.toggle(classes.hidden);
	}
};


const clearForm = el => {
	const avatar = el.querySelector(selectors.avatar);
	el.reset();
	clearAvatar(avatar);
};

const showStatus = el => () => {
	el.classList.add(classes.activeForm);
	clearForm(el);
	// setTimeout(() => {
	// 	el.classList.remove(classes.activeForm);
	// }, 3000);
};

const onSubmit = (success, url) => el => {
	sendForm(el, success(el), url);
};

const fade = item => {
	item.classList.remove(classes.fade);
};

const fadeAll = cards => () => forEach(fade, cards);

const animate = () => {
	const cards = qsa(selectors.cardReview);
	setTimeout(fadeAll(cards), 300);
};

const insert = (block, output) => {
	block.innerHTML = output.join(' ');
	animate();
};

const append = (block, output) => {
	output.map(item => {
		const div = document.createElement('span');
		div.innerHTML = item;
		block.appendChild(div.firstElementChild);
	});

	animate();
};

const renderCards = res => {
	const data = res.data;
	const container = qs(selectors.content);
	const review = $(selectors.review).clone()[0];
	const review1 = review;
	const template = compile(review);

	// showMore(build(template, data, container, append));
	const showMoreBtn = document.getElementsByClassName('show-more');

	showMoreBtn[0].addEventListener('click', () => {
		let tempScrollTop = 0;
		let loadingFlag = false;
		showMoreBtn[0].style.visibility = 'hidden';

		$(window).scroll(function () {
			const offset = document.getElementsByClassName('card-reviews').length;
			const preLast = offset - 1;
			const currentScrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
			const reviewOffset = $('.card-reviews:nth-child(' + preLast + ')').offset();
			const reviewPosition = reviewOffset.top;
			if (tempScrollTop < currentScrollTop ) {
				if (reviewPosition <= currentScrollTop && loadingFlag !== true) {
					loadingFlag = true;
					const http = new XMLHttpRequest();
					http.open('GET', '/reviews/chunk?offset=' + offset, true);
					http.setRequestHeader('Content-type', 'text/html; charset=UTF-8');
					http.send();
					http.onerror = err => {
						console.log(err.status);
					};
					http.onreadystatechange = () => {
						if (http.readyState === 4) {
							if (http.status === 200) {
								const result = JSON.parse(http.responseText);
								build(compile(review1), result.data, container, append)();
								loadingFlag = false;
							}
							else {
								console.log(http.status);
							}
						}
					};

				}
			}
			tempScrollTop = currentScrollTop;
		});

		const http = new XMLHttpRequest();
		const offset = document.getElementsByClassName('card-reviews').length;
		loadingFlag = true;
		http.open('GET', '/reviews/chunk?offset=' + offset, true);
		http.setRequestHeader('Content-type', 'text/html; charset=UTF-8');
		http.send();
		http.onerror = err => {
			console.log(err.status);
		};
		http.onreadystatechange = () => {
			if (http.readyState === 4) {
				if (http.status === 200) {
					const result = JSON.parse(http.responseText);
					build(compile(review1), result.data, container, append)();
					loadingFlag = false;
				}
				else {
					console.log(http.status);
				}
			}
		};
	});
	build(template, data, container, insert)();
};

const getData = () => {
	const http = new XMLHttpRequest();
	http.open('GET', '/reviews/chunk', true);
	http.setRequestHeader('Content-type', 'text/html; charset=UTF-8');
	http.send();
	http.onerror = err => {
		console.log(err.status);
	};
	http.onreadystatechange = () => {
		if (http.readyState === 4) {
			if (http.status === 200) {
				renderCards(JSON.parse(http.responseText));
			}
			else {
				console.log(http.status);
			}
		}
	};
};

const hidePlaceholders = () => {
	$(selectors.input).focus( function () {
		$(this).data('placeholder', $(this).attr('placeholder'));
		$(this).attr('placeholder', '');
	});
	$(selectors.input).blur( function () {
		$(this).attr('placeholder', $(this).data('placeholder'));
	});
};

const render = () => {
	if (isElement(selectors.form)) {
		bindEvent(selectors.button, 'click', onClick);
		bindEvent(selectors.close, 'click', onClick);

		forEach(onSubmit(showStatus, '/reviews/send'))(form());

		getData();
		hidePlaceholders();

		window.addEventListener('resize', pageToggler);
		window.addEventListener('orientationchange', pageToggler);
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/reviews/index.js